const PREVIEWABLE_IMAGE_EXTENSIONS = new Set([
  "apng",
  "avif",
  "bmp",
  "cur",
  "gif",
  "ico",
  "jfif",
  "jpeg",
  "jpg",
  "png",
  "svg",
  "svgz",
  "webp",
]);

const PREVIEWABLE_IMAGE_TYPES = new Set([
  "image/apng",
  "image/avif",
  "image/bmp",
  "image/gif",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/webp",
  "image/x-icon",
]);

export interface IPreviewableMedia {
  FileType?: string | null;
  Filename?: string | null;
  ContentType?: string | null;
}

const fileExtension = (filename: string | null | undefined): string => {
  const base = filename?.split(/[/\\]/).pop() ?? "";
  const dot = base.lastIndexOf(".");
  if (dot <= 0) {
    return "";
  }

  return base.slice(dot + 1).toLowerCase();
};

/** True when the media manager can show the file itself, not only a placeholder. */
export const isPreviewableMedia = (file: IPreviewableMedia): boolean => {
  const fileType = file.FileType?.toLowerCase() ?? "";
  if (fileType === "pdf" || fileType === "office" || fileType === "video") {
    return true;
  }

  if (fileType !== "image") {
    return false;
  }

  const extension = fileExtension(file.Filename);
  if (extension) {
    return PREVIEWABLE_IMAGE_EXTENSIONS.has(extension);
  }

  const contentType = file.ContentType?.split(";")[0]?.trim().toLowerCase() ?? "";
  return PREVIEWABLE_IMAGE_TYPES.has(contentType);
};
